import { connect } from 'react-redux';

import { IApplicationState } from '@store';

import DownloadResultsPackage, {
  DownloadResultsStateProps,
} from '../components/results/DownloadResultsPackage';

interface IMapStateToProps extends Pick<IApplicationState, 'accountInfo'> {}

const mapStateToProps = ({
  accountInfo,
}: IMapStateToProps): DownloadResultsStateProps => ({
  accountTimeZone: accountInfo.timezone,
});

export default connect(mapStateToProps)(DownloadResultsPackage);
